<template>
  <div
    ref="text"
    :class="[
      'tooltip',
      isClamped ? 'tooltip--clamped' : '',
      isClamped ? `tooltip--clamped-${rowCount}` : '',
      { 'tooltip--expanded': isExpanded },
    ]"
    :title="isClamped ? text : ''"
    @click="onTooltipClick"
    v-bind="$attrs"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'Tooltip',
  props: {
    text: {
      type: String,
      default: '',
    },
    rowCount: {
      type: Number,
      default: 4,
    },
  },
  data() {
    return {
      isClamped: false,
      isExpanded: false,
    }
  },
  mounted() {
    this.$nextTick(this.checkClamp)
  },
  methods: {
    onTooltipClick() {
      this.isExpanded = true
      this.checkClamp()
    },
    checkClamp() {
      if (this.isExpanded) {
        this.isClamped = false
        return
      }

      const el = this.$refs.text

      if (!el) {
        this.isClamped = false
        return
      }

      this.isClamped = el.scrollWidth > el.clientWidth || el.scrollHeight > el.clientHeight
    },
  },
}
</script>

<style lang="sass">
.tooltip
  overflow: auto

  &--clamped
    > *
      cursor: help
      overflow: hidden
      text-overflow: ellipsis
      display: -webkit-box
      -webkit-box-orient: vertical

  &--clamped-2
    > *
      -webkit-line-clamp: 2

  &--clamped-3
    > *
      -webkit-line-clamp: 3

  &--clamped-4
    > *
      -webkit-line-clamp: 4

  &--clamped-5
    > *
      -webkit-line-clamp: 5

  &--expanded
    overflow: hidden
    overflow-wrap: break-word
    word-wrap: break-word
</style>



// WEBPACK FOOTER //
// src/modules/shared/ui/lk/Tooltip.vue